import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getStartEndDate } from "../../../../helpers/getStartEndDate";
import { numberFormat } from "../../../../helpers/numberFormat";

const DetailPembayaranIndividu = () => {
  const size = useWindowSize();

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  const programSelected = useSelector((state) => state.programSelected);
  const scheduleSelected = useSelector((state) => state.scheduleSelected);
  const np = useSelector((state) => state.nominalPayment);

  // console.log(programSelected)

  return (
    <>
      <div className="row">
        <div className="card" style={{ backgroundColor: "#F2F2F2" }}>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#5E6278",
                    }}
                  >
                    <th>Nama Program</th>
                    <th>Jadwal Program</th>
                    <th>Harga</th>
                    <th className="text-center">Jumlah Peserta</th>
                  </tr>
                </thead>
                <tbody>
                  {programSelected.map((program, j) => (
                    <>
                      <tr
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          color: "#191919",
                        }}
                      >
                        <td>{program.name}</td>
                        <td>{getStartEndDate(scheduleSelected, program.id)}</td>
                        <td>
                          Rp. {numberFormat(program?.Pricebooks[0].price)}
                        </td>
                        <td className="text-center">1</td>
                      </tr>
                      <tr className="fw-bold fs-7 text-gray-800 border-bottom border-gray-200"></tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div
          className="col-lg-12 d-flex justify-content-end"
          style={{ textAlign: "right", marginLeft: "5px", marginTop: "2%" }}
        >
          <table width="60%" style={{ margin: "1%" }}>
            <tr>
              <th
                style={{
                  fontWeight: "500",
                  fontSize: size.width < 500 ? "12px" : "14px",
                  color: "#5E6278",
                }}
              >
                Sub Total
              </th>
              <th
                style={{
                  fontWeight: "600",
                  fontSize: size.width < 500 ? "12px" : "15px",
                }}
              >
                Rp. {numberFormat(np.nominalPayment.amount)}
              </th>
            </tr>

            <tr>
              <th
                style={{
                  fontWeight: "500",
                  fontSize: size.width < 500 ? "12px" : "14px",
                  color: "#5E6278",
                }}
              >
                PPN (12%)
              </th>
              <th
                style={{
                  fontWeight: "600",
                  fontSize: size.width < 500 ? "12px" : "15px",
                }}
              >
                Rp. {numberFormat(np.nominalPayment.ppn)}
              </th>
            </tr>

            <tr>
              <th
                style={{
                  fontWeight: "500",
                  fontSize: size.width < 500 ? "12px" : "14px",
                  color: "#5E6278",
                }}
              >
                Potongan Harga
              </th>
              <th
                style={{
                  fontWeight: "600",
                  fontSize: size.width < 500 ? "12px" : "15px",
                  color: "#F1416C",
                }}
              >
                - (Rp. {numberFormat(np.nominalPayment.deduction)})
              </th>
            </tr>

            <tr>
              <th></th>
              <th>______________________</th>
            </tr>

            <tr>
              <th
                style={{
                  fontWeight: "700",
                  fontSize: size.width < 500 ? "12px" : "16px",
                }}
              >
                Total
              </th>
              <th
                style={{
                  fontWeight: "700",
                  fontSize: size.width < 500 ? "12px" : "18px",
                  color: "#0C86D9",
                }}
              >
                Rp. {numberFormat(np.nominalPayment.grandtotal)}
              </th>
            </tr>
          </table>
        </div>
      </div>
    </>
  );
};

export default DetailPembayaranIndividu;
